// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorView_container__2HIM8","context":"ErrorView_context__2LDML","link":"ErrorView_link__3948h","text":"ErrorView_text__PJX2B"};